window.$ = {
  param: function (param)  {
    var str = '';
    for (var key in param) {
        if (str != '') str += '&';
        str += key + '=' + encodeURIComponent(param[key]);
    }
    return str;
}};



// WEBPACK FOOTER //
// ./src/helpers/helper.js